import React, { Component } from 'react';
import { Form, Modal, message } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
const { confirm } = Modal;
const api = services.api;
class Sendgoods extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    showModal = (sendOrderNo) => {
        console.log(sendOrderNo);
        const { entity } = this.props;
        // const { selectedKeys } = this.state;
        //     let sendOrderNo = selectedKeys.join(',');
        confirm({
            title: '确认发货?',
            content: '系统将通过接口从顺丰下单',
            onOk() {
                api.get(
                    { sendOrderNos: sendOrderNo },
                    { apiPath: `/8001/order/batch_delivery_new` }
                )
                    .then(() => {
                        message.success('发货成功');
                        entity.search({
                            ...entity.params,
                            ...entity.filters,
                        });
                    })
                    .catch(errorHandle);
            },
            onCancel() {
                console.log('Cancel');
            },
        });
        this.setState({
            visible: true,
        });
    };

    handleOk = (e) => {
        console.log(this.props.entity);
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let value;
                value = {
                    sale_num_status: values.saleNumStatus,
                };
                api.put(value, { apiPath: `/products/${this.props.rows.id}` })
                    .then(() => {
                        message.success('修改成功');
                    })
                    .catch(errorHandle);
                this.setState({
                    visible: false,
                });
                let params = {
                    type: 'FK_POINTS',
                };
                // 列表数据刷新
                this.props.x.search({
                    ...params,
                    ...this.props.entity.filters,
                });
            } else {
                message.error('请填写完整表单再提交');
            }
        });
    };

    render() {
        const {
            rows: { deliveryStatus, sendOrderNo },
        } = this.props;
        const { visible, inputVisible } = this.state;
        return (
            <div>
                {deliveryStatus == 1 && (
                    <a target="_blank" onClick={() => this.showModal(sendOrderNo)}>
                        发货
                    </a>
                )}
            </div>
        );
    }
}

export default Form.create()(Sendgoods);
